import React from 'react';

export default class OptGroup extends React.Component {

}



// WEBPACK FOOTER //
// ./_rc-select-6.4.8/src/OptGroup.jsx